import BaseEntityService from "core/framework/BaseEntityService";

export default class BaseRequestService extends BaseEntityService {
  constructor({ baseUrl }) {
    super({ baseUrl });
  }
}
